export default {"src":"/_next/static/media/Cataracts.459cbce8.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};